import {
  ssnSchema,
  ssnUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithRoleUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['supplemental--applicant-identity-info-title'];
const INPUT_LABEL = content['supplemental--applicant-ssn-label'];
const HINT_TEXT = content['supplemental--applicant-ssn-hint'];
const ERR_MSG = content['supplemental--applicant-ssn-error'];

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.beneficiary),
    applicantMemberNumber: {
      ...ssnUI(INPUT_LABEL),
      'ui:validations': [],
      'ui:errorMessages': {
        pattern: ERR_MSG,
        required: ERR_MSG,
      },
      'ui:options': { hint: HINT_TEXT },
    },
  },
  schema: {
    type: 'object',
    required: ['applicantMemberNumber'],
    properties: {
      applicantMemberNumber: ssnSchema,
    },
  },
};
